<app-navbar title="Karty płatnicze">
	<button class="btn btn-primary" (click)="dialogOpen()"><i class="fas fa-plus"></i> Dodaj</button>
</app-navbar>

<app-bank-card-set></app-bank-card-set>

<app-bank-cards-filters
	userFilters="bankCards"
	[paramFilters]="parameters"
	(selected)="filtersSelected($event)"
></app-bank-cards-filters>

<app-dynamic-table
	[elements]="data"
	[tableRows]="tableRows"
	module="bankCards"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table>
